exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cxContainer {\n  font-size: 1.4rem;\n}\n.dense {\n  padding: 1rem 1rem 0 1rem;\n}\n.open {\n  padding: 5rem 5rem 0 5rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/container/container.directive.less
// module id = 1480
// module chunks = 2